import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import {
  useIsReportBaseTemplate,
  useIsReportCompleted,
  useIsReportHandlebars,
  useIsReviewPage,
} from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION, RECOMMENDATIONS_PAGE_LOCATION } from "@components/ReportField/consts";
import { useAdminData } from "@providers/AdminDataProvider";
import { useReport } from "@providers/ReportProvider";

export const useCanEditSectionTitle = (section: ReportSectionsType): boolean => {
  const { report } = useReport();
  const { isCatalightUser } = useAdminData();
  const isHandlebars = useIsReportHandlebars();
  const isBaseTemplate = useIsReportBaseTemplate();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();

  if (isReviewPage || isCompleted) return false;

  if (report.reportType === ApiReportReportTypeChoices.InitialAssessment) {
    return isHandlebars;
  }

  if (report.reportType === ApiReportReportTypeChoices.DiagnosisEvaluation) {
    if (section.pageLocation === RECOMMENDATIONS_PAGE_LOCATION) return false;
    return isBaseTemplate || section.pageLocation === APPENDIX_PAGE_LOCATION;
  }

  if (report.reportType !== ApiReportReportTypeChoices.Reassessment) return false;
  return isHandlebars || (section.pageLocation === RECOMMENDATIONS_PAGE_LOCATION && !isCatalightUser);
};
